<template>
  <div class="d_general">
    <DemographyGeneral v-if="isDemography" :general="json_data.data.general" />
  </div>
  <div class="d_general">
    <DemographyAdvanced
      v-if="isDemography"
      :timestamp="timestamp"
      :json_data_advanced="json_data.data.advanced"
      :category="category"
    />
  </div>

  <div class="d_general">
    <PrestationGeneral v-if="isPrestation" :general="json_data.data.general" />
  </div>
  <div class="d_general">
    <PrestationAdvanced
      v-if="isPrestation"
      :timestamp="timestamp"
      :action="action"
      :json_data_advanced="json_data.data.advanced"
      :category="category"
    />
  </div>

  <div class="d_general">

    <AnalyseAdvanced
      v-if="isAnalyse"
      @get-client-stat="getClientStat"
      :timestamp="timestamp"
      :params="params"
      :action="action"
      :json_data_advanced="json_data.data.advanced"
      :json_data_table="json_data.data.table"
      :json_data_table_total="json_data.data.table_total"
      :json_data_frame="json_data.data.table_frame"
      :json_data_all_tables="json_data.data.all_tables"
      
    />
  </div>

</template>

<script>
import DemographyGeneral from "./Demography/General.vue";
import DemographyAdvanced from "./Demography/Advanced.vue";

import PrestationGeneral from "./Prestation/General.vue";
import PrestationAdvanced from "./Prestation/Advanced.vue";

import AnalyseAdvanced from "./Analyse/Advanced.vue";

export default {
  components: {
    DemographyGeneral,
    DemographyAdvanced,
    PrestationGeneral,
    PrestationAdvanced,
    AnalyseAdvanced,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    timestamp: {
      type: Number,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
    action: {
      type: String,
      required: true,
    },
    // graph: {
    //   type: String,
    //   required: true,
    // },
    category: {
      type: String,
      required: true,
    },
    json_data: {
      type: Object,
      required: true,
    },
  },
  emits: ["get-client-stat"],
  provide: {
    // colors: [],
    colors: [


    '#fcbf21',
    '#4fadea',
    '#9ec264',
    '#406db4',
    '#c896f8',
    '#ec6656',
    '#c17e2b',






    // '#d193ff',
    // '#00b0f0',
    // '#ff5a4e',
    // '#94c356',
    // '#fcbf21',
    // '#cc7a00',



      "green",
      "blue",
      "brown",
      "orange",
      "red",
      "violet",
      "#66C5D7",
      "#898BF3",
      "#02FA3E",
      "#0DF7FD",
      "#5C0CC6",
      "#09472C",
      "#701E4D",
      "#89BAAA",
      "#6D2E7F",
      "#872D8D",
      "#898940",
      "#A093DF",
      "#04CBF0",
      "#4EC198",
      "#7EA261",
      "#2CC992",
      "#4A71DC",
      "#63C20B",
      "#9419D3",
      "#9A8317",
    ],
  },
  methods: {
    getClientStat() {
      this.$emit("get-client-stat");
    },
  },
  computed: {
    graph(){
      return this.$route.params.graph
    },
    isDemography() {
      return this.graph === "pop";
    },
    isPrestation() {
      return this.graph === "sin";
    },
    isAnalyse() {
      return this.graph === "coti";
    },
  },
};
</script>

<style>
.d_general {
  width: 1100px;
  border-radius: 10px;
  margin: 20px auto 0;
  position: relative;
}
.g_frame {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 0 3px 0 #ccc;
  padding: 8px 12px;
  position: relative;
}
</style>